import { clientBuild } from './clientIdentity';
export function pathOnly(value) {
 const path=String(value || '/').split(/[?#]/)[0];
 return (path.startsWith('/') ? path:'/').replace(/\/(?:[0-9]+|(?:con|msg|cha|snp|att)_[a-f0-9]{32}|[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12})(?=\/|$)/gi,'/:id').replace(/[A-Za-z0-9_-]{48,}/g,'[omitted]').slice(0,255);
}
function cleanFrames(value,component=false) {
 return String(value || '').split('\n').filter(line => /^\s*at\s+/.test(line) || (!component && /^[\w.$<>]+@(?:https?:|file:)/.test(line)))
  .map(line => line.replace(/(?:https?:\/\/|file:\/\/)[^\s)]+/g,url => url.split(/[?#]/)[0]).replace(/(?:uzd_sk_|Bearer\s+)[^\s)]+/gi,'[redacted]').replace(/[A-Za-z0-9_-]{64,}/g,'[omitted]')).join('\n').slice(0,component ? 2000:6000);
}
// Custom exception text can contain form values/chat text. Keep standard runtime
// diagnostics only; never copy arbitrary thrown values or an API response body.
export function safeCrashMessage(error) {
 const message=typeof error?.message==='string' ? error.message:'';
 const diagnostics=[
  [/^Cannot read properties/,'Cannot read properties of a missing value.'],
  [/^Cannot set properties/,'Cannot set properties of a missing value.'],
  [/^Maximum update depth exceeded/,'Maximum update depth exceeded.'],
  [/^Rendered (more|fewer) hooks/,'The hook count changed between renders.'],
  [/^Invalid hook call/,'Invalid hook call.'],
  [/^Minified React error/,'A React rendering error occurred.'],
  [/^ResizeObserver loop/,'A resize observer loop occurred.'],
  [/^Script error/,'Script error.'],
  [/^(Failed to fetch dynamically imported module|Loading (CSS )?chunk [0-9]+ failed)/,'An application module could not be loaded.'],
 ];
 return diagnostics.find(([pattern])=>pattern.test(message))?.[1] || 'A client error occurred.';
}
export function clientErrorPayload(error,{route='/',componentStack='',requestId=null,apiStatus=null,apiCode=null}={}) {
 const code=/^[A-Z][A-Z0-9_]{0,79}$/.test(apiCode || '') ? ` · ${apiCode}`:'';
 const payload={ message:apiStatus ? `API request failed (HTTP ${Number(apiStatus)})${code}`:safeCrashMessage(error),stack:cleanFrames(error?.stack),component_stack:cleanFrames(componentStack,true),page_route:pathOnly(route),build_version:clientBuild,...(/^[A-Za-z0-9_-]{1,100}$/.test(requestId || '') ? {request_id:requestId}:{}) };
 while(new Blob([JSON.stringify(payload)]).size>15000 && (payload.stack || payload.component_stack)){payload.stack=payload.stack.slice(0,Math.floor(payload.stack.length/2));payload.component_stack=payload.component_stack.slice(0,Math.floor(payload.component_stack.length/2));}
 return payload;
}
